import {message} from 'antd';
import {t} from 'i18next';
import {useState} from 'react';
import {API_ENDPOINTS} from '@/constants';
import {Translation} from '@/models';

const useTranslateField = () => {
  const [isLoading, setIsLoading] = useState(false);

  const translateField = async (
    text: string,
    onSuccess: (data: Translation) => void
  ) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${API_ENDPOINTS.translation}&q=${text}&source=ar&target=en`
      );
      const resJson = await response.json();
      onSuccess(resJson.data?.translations?.[0]);
    } catch (err) {
      message.error(t('translationRequestError'));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    translateField,
  };
};

export default useTranslateField;
